import './index.css';
import App from './App';
import React from 'react';
import moment from 'moment';
import 'moment/locale/de-ch';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BookingProvider } from './BookingProvider';

moment.locale('de-ch');

ReactDOM.render(
  <React.StrictMode>
    <BookingProvider>
      <App />
    </BookingProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
